import { Component, Input, OnInit } from '@angular/core';
import { Review } from '../clcd.service';

@Component({
  selector: 'ag-clcd-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
})
export class ReviewsComponent implements OnInit {
  @Input() reviews: Review[];
  @Input() reviewLength = 500;
  @Input() numberOfReviews = 3;
  @Input() showMoreSize = 10;

  displayedReviews: Review[];
  constructor() {}

  ngOnInit() {
    if (this.reviews) {
      this.displayedReviews = this.reviews.slice(0, this.numberOfReviews);
    }
  }

  showMoreReviews() {
    this.displayedReviews.push(
      ...this.reviews.slice(
        this.displayedReviews.length,
        this.displayedReviews.length + this.showMoreSize > this.reviews.length
          ? this.reviews.length
          : this.displayedReviews.length + this.showMoreSize,
      ),
    );
  }
}
